<template>
  <refonte-modal
    v-bind:show="props.show"
    v-on:close="props.on_close"
    title="Signature en cours"
    class="!max-w-[720px]">
    <template v-slot:modalBody>
      <div
        class="gap-[12px]"
        v-if="props.show_body">
        La procédure de signature a été déclenchée le
        <span class="font-bold"> {{ formatDate(props.date) }}</span
        >. Un mail a été envoyé à l'adresse
        <span class="font-bold">{{ props.email }}</span
        >.<br /><br />
        Pour annuler la procédure, cliquez sur "{{ props.cancel_label }}" (cette
        action est irréversible).
      </div>
    </template>
    <template v-slot:modalFooter>
      <refonte-button
        variant="secondary"
        v-bind:on_click="props.on_close">
        Fermer
      </refonte-button>
      <refonte-button
        variant="primary"
        v-bind:on_click="cancel">
        {{ props.cancel_label }}
      </refonte-button>
    </template>
  </refonte-modal>
  <refonte-modal-file-signature-details-in-progress-confirmation
    v-bind:show="isConfirmationQuestionModalOpen"
    v-bind:on_close="closeConfirmationQuestionModalOpen"
    v-bind:on_submit="submit" />
  <refonte-modal-confirmation-action
    v-bind:show="isConfirmationActionDoneModalOpen"
    v-bind:on_close="closeConfirmationActionDoneModal"
    title=""
    content="La procédure de signature a été annulée avec succès." />
  <refonte-modal-file-signature-details-maintenance
    v-bind:show="isSignatureMaintenanceModalOpen"
    v-bind:on_close="() => setIsSignatureMaintenanceModalOpen(false)" />
  <refonte-modal-confirmation-action
    v-bind:show="isErrorModalOpen"
    v-bind:on_close="closeErrorModal"
    title="Erreur lors de l'annulation de la collecte"
    content="Une erreur est survenue lors de l'annulation de la signature. Veuillez réeesayer ultérireurement ou contacter votre adminsitrateur." />
</template>

<script setup lang="ts">
  import RefonteModal from '@/components/refonte/modals/refonte-modal.vue';
  import RefonteButton from '@/components/refonte/buttons/refonte-button.vue';
  import { ref } from 'vue';
  import RefonteModalConfirmationAction from '@/components/refonte/modals/refonte-modal-confirmation-action.vue';
  import { API } from '@/http-common';
  import RefonteModalFileSignatureDetailsInProgressConfirmation from '@/components/refonte/modals/refonte-modal-file-signature-details-in-progress-confirmation.vue';
  import RefonteModalFileSignatureDetailsMaintenance from '@/components/refonte/modals/refonte-modal-file-signature-details-maintenance.vue';
  import { parse } from 'date-fns';

  const props = withDefaults(
    defineProps<{
      show: boolean;
      on_close: Function;
      on_submit?: Function;
      class?: string;
      client_id?: number;
      show_body: boolean;
      date?: string;
      email?: string;
      signature_maintenance?: boolean;
      cancel_url?: string;
      cancel_label?: string;
    }>(),
    {
      class: '',
      cancel_label: 'Annuler la signature en cours'
    }
  );

  const isErrorModalOpen = ref<boolean>(false);
  const isSignatureMaintenanceModalOpen = ref<boolean>(false);
  const setIsSignatureMaintenanceModalOpen = (value: boolean) => {
    isSignatureMaintenanceModalOpen.value = value;
  };
  const closeErrorModal = () => {
    isErrorModalOpen.value = false;
    props.on_close();
    closeConfirmationQuestionModalOpen();
  };

  const cancel = () => {
    if (props.signature_maintenance) {
      setIsSignatureMaintenanceModalOpen(true);
    } else {
      openConfirmationQuestionModalOpen();
    }
  };
  const annulerSignature = async () => {
    if (props.cancel_url) {
      try {
        const response = await API.delete(props.cancel_url, {
          headers: { 'SKIP-REDIRECTION': true }
        });
        if (response.status == 200) {
          isConfirmationActionDoneModalOpen.value = true;
        } else {
          isErrorModalOpen.value = true;
        }
      } catch (e) {
        isErrorModalOpen.value = true;
      }
    }
  };

  const submit = async () => {
    await annulerSignature();
  };

  const isConfirmationActionDoneModalOpen = ref<boolean>(false);

  const closeConfirmationActionDoneModal = () => {
    isConfirmationActionDoneModalOpen.value = false;
    if (props.on_submit) {
      props.on_submit();
    }
    props.on_close();
    closeConfirmationQuestionModalOpen();
  };
  const isConfirmationQuestionModalOpen = ref<boolean>(false);

  const closeConfirmationQuestionModalOpen = () => {
    isConfirmationQuestionModalOpen.value = false;
  };

  const openConfirmationQuestionModalOpen = () => {
    isConfirmationQuestionModalOpen.value = true;
  };

  const formatDate = (dateString: string | undefined) => {
    if (!dateString) return '';

    const date = parse(dateString, 'dd/MM/yyyy HH:mm:ss', new Date());

    const datePart = date.toLocaleDateString('fr-FR');
    const timePart = date
      .toLocaleTimeString('fr-FR', {
        hour: '2-digit',
        minute: '2-digit'
      })
      .replace(':', 'h');

    return `${datePart} à ${timePart}`;
  };
</script>

<style lang="scss" scoped></style>
